import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/viewport'
import { css } from '@emotion/react'
import { CompositeComponent, Optional } from 'lib'
import { CSSProperties } from 'react'

const commonStyles = css`
	line-height: 132%;
`

const H1 = styled.h1`
	${commonStyles};
	font-size: 2.5rem;
	${mediaQueriesByDevice.mobile} {
		font-size: 1.875rem;
	}
`

const H2 = styled.h2`
	${commonStyles};
	font-size: 2rem;
	${mediaQueriesByDevice.mobile} {
		font-size: 1.5rem;
	}
`

const H3 = styled.h3`
	${commonStyles};
	font-size: 1.5rem;
	${mediaQueriesByDevice.mobile} {
		font-size: 1.375rem;
	}
`

const H4 = styled.h4`
	${commonStyles};
	font-size: 1.25rem;
`

const H5 = styled.h5`
	${commonStyles};
	font-size: 0.75rem;
`

type Props = Optional<CSSProperties>
type HeadingSize = 'H1' | 'H2' | 'H3' | 'H4' | 'H5'

export const Heading: CompositeComponent<Props, HeadingSize, Props> = ({ children, ...props }) => (
	<H1 style={props}>{children}</H1>
)
Heading.H1 = ({ children, ...props }) => <H1 style={props}>{children}</H1>
Heading.H2 = ({ children, ...props }) => <H2 style={props}>{children}</H2>
Heading.H3 = ({ children, ...props }) => <H3 style={props}>{children}</H3>
Heading.H4 = ({ children, ...props }) => <H4 style={props}>{children}</H4>
Heading.H5 = ({ children, ...props }) => <H5 style={props}>{children}</H5>
